import { attributesLabels, checkboxAttributes } from '@/helpers/domain-whois'

export default {
  data () {
    return {
      attrsVisibility: {},
      extAttributes: null,
      model: {
        attributes: {},
      },
    }
  },
  methods: {
    resolveItems (items) {
      if (!items) return []
      const clearItems = JSON.parse(JSON.stringify(items))
      if (!Array.isArray(clearItems)) {
        return [clearItems]
      }
      return clearItems
    },
    isEditableAttribute ({ Name, Options, UserDefined }) {
      if (UserDefined == 'False') {
        return !!Array.isArray(Options.Option)
      }
      return true
    },
    getAttributeLabel ({ Name = '' }) {
      if (typeof attributesLabels[Name] !== 'undefined') {
        // take label from vocab
        return attributesLabels[Name].label
      }
      return Name.split('_')
        .splice(1)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
    attributeValidationRules (attr) {
      return {
        required: attr.Required === '1'
      }
    },
    defineAttributeComponent (attr) {
      if (attr.UserDefined === 'False') {
        if (checkboxAttributes.indexOf(attr.Name) !== -1) {
          return 'v-checkbox'
        }
        return 'gg-select'
      }
      return 'gg-text-field'
    },
    conditionalAttributesVisible (attributes) {
      if (!this.isAttributes) {
        return
      }
      this.$nextTick(() => {
        // initial visibility
        this.attrsVisibility = attributes.reduce((carry, attr) => {
          carry[attr.Name] = attr.IsChild === '0'
          return carry
        }, {})
        // always visible attrs (parent)
        const parentAttrs = attributes.filter(attr => attr.IsChild === '0')
        const visibility = attributes.filter(attr => attr.IsChild === '1')
          .reduce((carry, attr) => {
            carry[attr.Name] = !!parentAttrs.find(parent => {
              if (typeof parent.Options.Option === 'undefined' || typeof parent.Options.Option.find !== 'function') {
                return false
              }
              return parent.Options.Option.find(option => {
                if (typeof option.Requires === 'undefined') {
                  return false
                }
                const currentVal = typeof this.model.attributes[parent.Name] === 'object'
                  ? this.model.attributes[parent.Name].Value
                  : this.model.attributes[parent.Name]
                return option.Requires.Attribute.Name == attr.Name && currentVal == option.Value
              })
            })
            return carry
          }, {})
        this.attrsVisibility = {
          ...this.attrsVisibility,
          ...visibility
        }
      })
    },
    // initAttributesValues (attributes) {
    //   this.model.attributes = attributes.reduce((carry, { Name, Options, UserDefined }) => {
    //     if (this.isEditableAttribute({ Name, Options, UserDefined })) {
    //       carry[Name] = typeof this.domain.CurrentAttributes[Name] !== 'undefined' ? this.domain.CurrentAttributes[Name] : ''
    //     }
    //     return carry
    //   }, {})
    // },
  },
}
